import { render, staticRenderFns } from "./Tipoutilizzo.vue?vue&type=template&id=95421b4c&scoped=true&"
import script from "./Tipoutilizzo.vue?vue&type=script&lang=js&"
export * from "./Tipoutilizzo.vue?vue&type=script&lang=js&"
import style0 from "./Tipoutilizzo.vue?vue&type=style&index=0&id=95421b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95421b4c",
  null
  
)

export default component.exports